import React from "react";
import { FailedToLoadDataIcon } from "../../../assets/icons";
import styles from "./FailedToLoadData.module.scss";

interface FailedToLoadDataProps {
	text?: string;
}

export const FailedToLoadData: React.FC<FailedToLoadDataProps> = ({ text = "Failed to load data. Please try again." }) => {
	return (
		<div className={styles.container}>
			<FailedToLoadDataIcon className={styles.icon} />
			<p className={styles.text}>{text}</p>
		</div>
	);
};
